import { shouldRouteDashboardHostToCms } from "@playbrain/config/dashboard-host"
import { currentRequestHostname } from "@playbrain/config/dashboard-host-runtime"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    if (shouldRouteDashboardHostToCms(await currentRequestHostname(), "/")) {
      throw redirect({ href: "/dashboard" })
    }
    throw redirect({ href: "/ja" })
  },
})
